import {
  IProduct,
  IUser,
  IUserBridge,
  ISharingProduct,
  IPurchaseCompleted,
  IQuantity
} from "./Interfaces";

declare const OGWebBridge: any;
const baseURL : string = "https://demoshop.mobilelab.io";
// Funktionen zum Bearbeiten der Strings bzgl. der Webbridgeevents

export function makeBridgeString(key: string, value: string): string {
  const ifUndef: string = 'if (typeof OGWebBridge !== "undefined")';
  let bridge: string = `{OGWebBridge.update("${key}", "${value}")}`;
  bridge = ifUndef + bridge;
  return bridge;
}

export function makeBridgeStringBool(key: string, value: string): string {
  const ifUndef: string = 'if (typeof OGWebBridge !== "undefined")';
  let bridge: string = `{OGWebBridge.update("${key}", ${value})}`;
  bridge = ifUndef + bridge;
  return bridge;
}

export function makeBridgeStringObject(key: string, value: string): string {
  const ifUndef: string = 'if (typeof OGWebBridge !== "undefined")';
  let bridge: string = `{OGWebBridge.update("${key}", '${value}')}`;
  bridge = ifUndef + bridge;
  return bridge;
}

export function makeBridgeStringObjectArray( key: string,values: string[]): string {
  const ifUndef: string = 'if (typeof OGWebBridge !== "undefined")';
  let all: string = "";
  values.forEach((value: string) => {
    all = all + value;
  });

  let bridge: string = `{OGWebBridge.update("${key}", '[${all}]')}`;
  bridge = ifUndef + bridge;
  return bridge;
}

export function getUserInfoString(customer: IUser): string {
  const customerInfo: IUserBridge = {
    gender: customer.gender,
    firstName: customer.firstName,
    lastName: customer.lastName,
    roles: []
  };
  const customerString: string = JSON.stringify(customerInfo);
  return customerString;
}

export function getSharingString(product: IProduct, url: string): string {
  const linkTotal: string =
    baseURL + url;
  const sharingProduct: ISharingProduct = {
    title: product.name,
    link: linkTotal
  };
  const sharingString: string = JSON.stringify(sharingProduct);
  return sharingString;
}

export function getPurchaseCompletedString(products: IProduct[],quantity: IQuantity[]): string[] {
  const purchaseProductsString: any[] = [];
  products.forEach((product: IProduct) => {
    let elemQuantity: IQuantity = { id: "0", quantity: 0 };
    const dummyQuantity: any = quantity.find(item => item.id === product.id);
    if (dummyQuantity !== undefined) {
      elemQuantity = dummyQuantity;
    }
    const purchaseProduct: IPurchaseCompleted = {
      itemAmount: product.price.toString(),
      currency: "EUR",
      itemName: product.name,
      itemId: product.id
    };
    while (elemQuantity.quantity > 0) {
      const purchaseString: string = JSON.stringify(purchaseProduct);
      purchaseProductsString.push(purchaseString);
      elemQuantity.quantity = elemQuantity.quantity - 1;
    }
  });
  return purchaseProductsString;
}

export function setHapticFeedback(typeString : string) : any {
  const hapticFeedback: any = { type: typeString }; 
  if (typeof OGWebBridge !== "undefined"){
      OGWebBridge.update("hapticFeedback", JSON.stringify(hapticFeedback))
  }
}


// WEBPACK FOOTER //
// ./src/functions/WebbridgeFunctions.ts